<template>
    <div>
        <van-nav-bar
      :title="t('email.title')"
      :border="false"
      class="custom-nav-bar"
      >
      <template #left>
        <Button type="back" @click="onClickLeft" />
      </template>
    </van-nav-bar>
    <div class="mt-[17px] mx-[11px]">
          <div class="color-[#5FB589] text-[10px] mt-[8px]">{{ t('email.setNewPasswordAfterVerify') }}</div>
          <div class="auth-input-row mt-[30px]" :class="{ 'input-error': emailError }">
            <input
              v-model="emailForm.email"
              class="auth-input"
              type="text"
              :placeholder="t('email.email')"
              @input="onEmailInput"
              @blur="validateEmail"
            >
            <img
              v-if="emailForm.email"
              :src="getAssetsFile('home/closes.png')"
              alt=""
              class="h-[11px] w-[11px]"
              @click="emailForm.email = ''"
            >
          </div>
        <div class="flex justify-center items-center mt-[30px]">
        <div class="anniu" @click="handleBindEmail()" :class="{ 'auth-btn-disabled': isLoading }">
          {{ isLoading ? t('email.confirm') : t('email.confirm') }}
        </div>
        </div>
    </div>
    </div>
</template>
<script setup lang="ts">
import { Button } from "@/components/Button"
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { bindEmailReward } from '@/api/game'

const { t } = useI18n()
const router = useRouter()
const onClickLeft = () => {
  router.back()
}

const emailForm = ref({
  email: ''
})
const emailError = ref(false)
const emailErrorMessage = ref('')
const isLoading = ref(false)

const onEmailInput = () => {
  emailForm.value.email = emailForm.value.email.trim()
  // 实时验证
  validateEmail()
}

const validateEmail = () => {
  const email = emailForm.value.email
  if (!email) {
    emailError.value = false
    emailErrorMessage.value = ''
    return
  }

  // 不需要验证邮箱格式，只需要检查是否为空
  if (email.length === 0) {
    emailError.value = true
  } else {
    emailError.value = false
    emailErrorMessage.value = ''
  }
}

// 绑定邮箱
const handleBindEmail = async () => {
  // 验证邮箱
  if (!emailForm.value.email) {
    emailError.value = true
    return
  }

  if (emailError.value) {
    return
  }

  try {
    isLoading.value = true

    // 调用绑定邮箱接口
    const response = await bindEmailReward(emailForm.value.email)

    if (response.data) {
      router.push('/security')
    } else {
      // 绑定失败
      emailError.value = true
    }

  } catch (error) {
    console.error('绑定邮箱失败:', error)
    emailError.value = true
  } finally {
    isLoading.value = false
  }
}
</script>
<style lang="scss" scoped>
.custom-nav-bar {
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.3), 0px -2px 22px 0px rgba(53,189,128,0.61);
  &>* {
    height: 100%;
  }
}
.auth-input-row {
display: flex;
border-radius: 6px;
align-items: center;
display: flex;
border:1px solid #349C75;
align-items: center;
padding: 0 11px;
margin-top: 20px;
transition: border-color 0.3s ease;
}
.auth-input-row.input-error {
border: 1px solid #ff4d4f !important;
}
.auth-img-placeholder {
width: 28px;
height: 28px;
background: #1a4d3a;
border-radius: 6px;
margin-right: 8px;
}
.auth-input {
flex: 1;
height: 40px;
border-radius: 8px;
border: none;
padding: 0 12px 0 0;
background: none;
color: #fff;
font-size: 12px;
caret-color: #50d38c;
}
.input-error-tip {
display: flex;
align-items: baseline;
color: #ff4d4f;
font-size: 12px;
}
input[type='checkbox'] {
accent-color: #50d38c;
}
.input-error {
border: 1px solid #ff4d4f !important;
}
.input-error-tip {
display: flex;
align-items: baseline;
color: #ff4d4f;
font-size: 12px;
}
.input-tip {
display: flex;
align-items: baseline;
color: #50d38c;
font-size: 12px;
}
.auth-btn-disabled {
background: #126736 !important;
cursor: not-allowed !important;
opacity: 0.6;
}

.auth-btn:disabled {
background: #126736 !important;
cursor: not-allowed !important;
opacity: 0.6;
}
input::placeholder {
color: #096;
font-size: 12px;
}
.anniu{
  width: 275px;
height: 35px;
background: linear-gradient(0deg, #379753 0%, #46C96D 100%);
border-radius: 11px;
color: #fff;
font-size: 13px;
text-align: center;
line-height:35px;
font-weight: bold;
}
</style>
<route lang="json5">
    {
      name: 'email',
      meta: {
        title: 'email',
        i18n: 'email'
      },
    }
</route>
